<template>
  <ViewVisibility></ViewVisibility>
</template>
<script>
import ViewVisibility from "@/components/IAReputation/Views/Visibility.vue"

export default {
  components: {ViewVisibility},
}
</script>
